// // import React from "react";
// // import YenimahalleSidebar from "../Sidebar/YenimahalleSidebar";
// // import YenimahalleOtherServices from "../ServiceAreas/YenimahalleServiceAreas";

// // import LeftSidebar from "../../Sidebars/LeftSidebar";
// // import RightSidebar from "../../Sidebars/RightSidebar";

// // const YenimahalleIntro = () => {
// //   return (
// //     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
// //       <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
// //         YENİMAHALLE HALI-KOLTUK YIKAMA
// //       </h1>

// //       <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        

// //         {/* İçerik */}
// //           <div className="order-1 md:order-2 md:col-span-2 space-y-6">
// //           <p>
// //             Kaliteli temizlik gerektikçe Ankara’daki birçok muayel yıkama çözümü
// //             cazip tarifik kampanya afişleriyle dolu olur. Abone Halı Yıkama tam
// //             anlamıyla hijyenik ve detaylı hizmet sunar. Halılarınız,
// //             koltuklarınız ve ev tekstil ürünleriniz, %100 müşteri memnuniyeti
// //             odaklı bir hizmet anlayışıyla teslim alınır, özel sistemlerle
// //             detaylı şekilde yıkanır ve zamanında geri teslim edilir.
// //           </p>

// //           <p>
// //             Evde çocuk, yaşlı, alerjik birey varsa, temizliğinizin kalitesine
// //             güvenmek sizin de en doğal hakkınız. Bu yüzden biz sadece temizlik
// //             değil; hijyen, güvenlik ve zamanında teslim sözünü de veriyoruz.
// //             Ayrıca her halı için uygun yıkama yöntemi kullanılır.
// //           </p>

// //           <p>
// //             <strong>
// //               Abone Halı Yıkama olarak sağladığımız avantajlar şunlardır:
// //             </strong>
// //           </p>

// //           <ul className="list-disc list-inside">
// //             <li>Daha Sağlıklı Bir Çevre</li>
// //             <li>
// //               Derinlemesine temizlik: Halı, koltuk, perde, yorgan, battaniye
// //               gibi tüm ev tekstili ürünlerinde tam çözüm
// //             </li>
// //             <li>Antibakteriyel ve Alerjenlerden Arınmış Hijyen</li>
// //             <li>Yerinde Yıkama & Fabrikada Yıkama Seçeneği</li>
// //             <li>Kısa Sürede Teslim</li>
// //             <li>Leke Çıkartma Garantisi</li>
// //           </ul>

// //           <p>
// //             Halılarınızda oluşan lekeleri, tozları, kötü kokuları gideriyoruz.
// //             Koltuk yıkamada ise kumaş yapısına göre uygun kimyasal ve buhar
// //             sistemi kullanıyoruz.
// //           </p>

// //           <p>
// //             Çakırlar, Demet, İvedik gibi birçok mahallede mobil araçlarımızla
// //             aynı gün içinde yerinden alım ve teslimat hizmetimiz mevcuttur.
// //           </p>

// //           <p>
// //             Koltuk yıkama, halı şampuanı ve buharlı sistemlerle yapılan detaylı
// //             bir işlemdir. Kumaşa zarar vermeden, kir tabakasını yok eder,
// //             alerjenleri yok eder.
// //           </p>

// //           <p>
// //             Bazı durumlarda, halı tamparsuru ve buharlı temizleme makineleri
// //             gibi halılarınızın kabarma ve konumlarını bozmayacak özel ekipmanlar
// //             kullanılır. Bu sayede hem görünüm hem de temizlik seviyesi artar.
// //             Ayrıca halılarınız özel filelerle paketlenerek teslim edilir.
// //           </p>

// //           <p>
// //             Hizmet verdiğimiz tüm mahallelerde, profesyonel ve güler yüzlü
// //             personelimizle çalışıyoruz. Batıkent, Ergazi, Demetevler, Ata gibi
// //             tüm lokasyonlara hızlı servis!
// //           </p>

// //           <p>
// //             Bizim için müşteri memnuniyeti her şeydir. Halı ve koltuk yıkama
// //             gibi hijyenik çözümlerde bizi tercih ettiğiniz için teşekkür ederiz.
// //             Hemen <strong>iletisim</strong> sayfamızdan bize ulaşarak sipariş
// //             verebilir veya fiyat bilgisi alabilirsiniz.
// //           </p>
// //           {/* Sol sidebarlar */}
      
// //           <YenimahalleSidebar />
// //           <YenimahalleOtherServices />
       
// //         </div>
// //         {/* Sol Sidebar */}
// //         <div className="order-2 md:order-1 space-y-6">
// //           <LeftSidebar />
// //         </div>

// //           {/* Sağ Sidebar */}
// //         <div className="order-3 md:order-3 space-y-6">
// //           <RightSidebar />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default YenimahalleIntro;
// import React from "react";
// import YenimahalleSidebar from "../Sidebar/YenimahalleSidebar";
// import YenimahalleOtherServices from "../ServiceAreas/YenimahalleServiceAreas";
// import LeftSidebar from "../../Sidebars/LeftSidebar";
// import RightSidebar from "../../Sidebars/RightSidebar";

// const YenimahalleIntro = () => {
//   return (
//     <section className="relative overflow-hidden mt-[-95px] bg-gradient-to-b from-[#f8fafc] via-[#fffaf0] to-[#eef7f1] pt-0 mt-0 px-4 pb-12">
//       <div className="absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#d6b56d]/25 blur-3xl" />
//       <div className="absolute top-40 -right-32 h-96 w-96 rounded-full bg-emerald-200/30 blur-3xl" />

//       <div className="relative max-w-screen-xl mx-auto">
//         <div className="mb-10 text-center">
//           {/* <span className="inline-flex rounded-full border border-[#d6b56d]/50 bg-white/80 px-5 py-2 text-sm font-bold text-[#6b3b16] shadow-sm">
//             Abone Halı Yıkama
//           </span> */}

//           <h1 className="mt-5 text-3xl md:text-5xl font-bold tracking-tight text-[#1f160f]">
//             YENİMAHALLE HALI & KOLTUK YIKAMA
//           </h1>

//           <p className="mx-auto mt-5 max-w-3xl text-base md:text-lg leading-8 text-gray-700">
//             Yenimahalle ve çevresinde halı, koltuk, perde, yorgan ve battaniye
//             yıkama hizmetlerinde hijyen, güven ve zamanında teslim odaklı
//             profesyonel temizlik çözümleri sunuyoruz.
//           </p>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-7 items-start">
//           <aside className="order-2 lg:order-1 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
//             <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
//               <LeftSidebar />
//             </div>
//           </aside>

//           <main className="order-1 lg:order-2 lg:col-span-6">
//             <article className="rounded-[30px] border border-[#ead9b7] bg-white/95 p-6 md:p-8 shadow-[0_25px_70px_rgba(15,23,42,0.10)]">
//               <div className="prose prose-lg max-w-none prose-p:text-gray-700 prose-p:leading-8 prose-strong:text-[#2b160b] prose-li:text-gray-700">
//                 <p>
//                    Abone Halı Yıkama tam anlamıyla hijyenik ve detaylı hizmet sunar.
//                   Halılarınız, koltuklarınız ve ev tekstil ürünleriniz, %100
//                   müşteri memnuniyeti odaklı bir hizmet anlayışıyla teslim alınır,
//                   özel sistemlerle detaylı şekilde yıkanır ve zamanında geri
//                   teslim edilir.
//                 </p>

//                 <p>
//                   Evde çocuk, yaşlı, alerjik birey varsa, temizliğinizin
//                   kalitesine güvenmek sizin de en doğal hakkınız. Bu yüzden biz
//                   sadece temizlik değil; hijyen, güvenlik ve zamanında teslim
//                   sözünü de veriyoruz. Ayrıca her halı için uygun yıkama yöntemi
//                   kullanılır.
//                 </p>

//                 <div className="my-7 rounded-2xl border border-emerald-100 bg-emerald-50/70 p-5">
//                   <p className="!mt-0 font-bold text-[#0f3d2e]">
//                     Abone Halı Yıkama olarak sağladığımız avantajlar şunlardır:
//                   </p>

//                   <ul className="mt-4 grid gap-3 pl-0 list-none">
//                     <li>✓ Daha sağlıklı bir çevre</li>
//                     <li>✓ Halı, koltuk, perde, yorgan ve battaniyede tam çözüm</li>
//                     <li>✓ Antibakteriyel ve alerjenlerden arınmış hijyen</li>
//                     <li>✓ Yerinde yıkama ve fabrikada yıkama seçeneği</li>
//                     <li>✓ Kısa sürede teslim</li>
//                     <li>✓ Leke çıkarma garantisi</li>
//                   </ul>
//                 </div>

//                 <p>
//                   Halılarınızda oluşan lekeleri, tozları ve kötü kokuları
//                   gideriyoruz. Koltuk yıkamada ise kumaş yapısına göre uygun
//                   kimyasal ve buhar sistemi kullanıyoruz.
//                 </p>

//                 <p>
//                   Çakırlar, Demet, İvedik gibi birçok mahallede mobil
//                   araçlarımızla aynı gün içinde yerinden alım ve teslimat
//                   hizmetimiz mevcuttur.
//                 </p>

//                 <p>
//                   Koltuk yıkama, halı şampuanı ve buharlı sistemlerle yapılan
//                   detaylı bir işlemdir. Kumaşa zarar vermeden kir tabakasını ve
//                   alerjenleri uzaklaştırır.
//                 </p>

//                 <p>
//                   Bazı durumlarda halılarınızın dokusunu bozmayacak özel
//                   ekipmanlar kullanılır. Bu sayede hem görünüm hem de temizlik
//                   seviyesi artar. Ayrıca halılarınız özel filelerle paketlenerek
//                   teslim edilir.
//                 </p>

//                 <p>
//                   Hizmet verdiğimiz tüm mahallelerde, profesyonel ve güler yüzlü
//                   personelimizle çalışıyoruz. Batıkent, Ergazi, Demetevler, Ata
//                   gibi tüm lokasyonlara hızlı servis sağlıyoruz.
//                 </p>

//                 <p>
//                   Bizim için müşteri memnuniyeti her şeydir. Hemen{" "}
//                   <strong>iletişim</strong> sayfamızdan bize ulaşarak sipariş
//                   verebilir veya fiyat bilgisi alabilirsiniz.
//                 </p>
//               </div>

//               <div className="mt-8 space-y-6">
//                 <YenimahalleSidebar />
//                 <YenimahalleOtherServices />
//               </div>
//             </article>
//           </main>

//           <aside className="order-3 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
//             <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
//               <RightSidebar />
//             </div>
//           </aside>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default YenimahalleIntro;

import React from "react";
import YenimahalleSidebar from "../Sidebar/YenimahalleSidebar";
import YenimahalleOtherServices from "../ServiceAreas/YenimahalleServiceAreas";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const YenimahalleIntro = () => {
  return (
    <section className="relative overflow-hidden mt-[-95px] bg-gradient-to-b from-[#f8fafc] via-[#fffaf0] to-[#eef7f1] pt-0 px-4 pb-12">
      <div className="absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#d6b56d]/25 blur-3xl" />
      <div className="absolute top-40 -right-32 h-96 w-96 rounded-full bg-emerald-200/30 blur-3xl" />

      <div className="relative max-w-screen-xl mx-auto">
        <div className="mb-8 text-center pt-8">
          <span className="inline-flex rounded-full border border-[#d6b56d]/50 bg-white/90 px-5 py-2 text-sm font-bold text-[#6b3b16] shadow-sm">
            Yenimahalle Profesyonel Halı Yıkama Hizmeti
          </span>

          <h1 className="mt-5 text-3xl md:text-5xl font-extrabold tracking-tight text-[#1f160f]">
            Yenimahalle Halı Yıkama ve Koltuk Yıkama
          </h1>

          <p className="mx-auto mt-5 max-w-4xl text-base md:text-lg leading-8 text-gray-700">
            <strong>Yenimahalle halı yıkama</strong> hizmetinde Abone Halı
            Yıkama; hijyenik yıkama, yerinden alım, zamanında teslim ve müşteri
            memnuniyeti odaklı profesyonel temizlik çözümleri sunar. Batıkent,
            Demetevler, İvedik, Çakırlar, Karşıyaka, Ostim, Ergazi ve çevre
            mahallelerde halı, koltuk, perde, yorgan ve battaniye yıkama
            hizmeti veriyoruz.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="tel:+905015336066"
              className="rounded-full bg-[#2f160b] px-7 py-3 text-sm font-bold text-[#f8e6b2] shadow-lg hover:scale-105 transition"
            >
              Hemen Ara
            </a>

            <a
              href="https://wa.me/905015336066"
              className="rounded-full bg-green-600 px-7 py-3 text-sm font-bold text-white shadow-lg hover:scale-105 transition"
            >
              WhatsApp Teklif Al
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-7 items-start">
          <aside className="order-2 lg:order-1 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
            <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
              <LeftSidebar />
            </div>
          </aside>

          <main className="order-1 lg:order-2 lg:col-span-6">
            <article className="rounded-[30px] border border-[#ead9b7] bg-white/95 p-6 md:p-8 shadow-[0_25px_70px_rgba(15,23,42,0.10)]">
              <div className="space-y-5 text-[16px] leading-8 text-gray-700 text-justify">
                <h2 className="text-2xl md:text-3xl font-bold text-[#1f160f] text-left">
                  Yenimahalle’de Hijyenik ve Güvenilir Halı Yıkama
                </h2>

                <p>
                  Abone Halı Yıkama, Yenimahalle bölgesinde halı yıkama ve
                  koltuk yıkama hizmetlerinde detaylı temizlik anlayışıyla
                  çalışır. Halılarınız evinizden teslim alınır, halı türüne ve
                  kirlilik durumuna göre uygun yıkama yöntemi belirlenir,
                  profesyonel makinelerde yıkanır, durulanır, kurutulur ve
                  paketlenerek teslim edilir.
                </p>

                <p>
                  Evde çocuk, yaşlı veya alerjik birey varsa, halı ve koltuk
                  temizliği yalnızca görüntü için değil sağlık açısından da
                  önemlidir. Bu yüzden Yenimahalle halı yıkama hizmetimizde
                  hijyen, kötü koku giderme, toz ve alerjen temizliği öncelikli
                  olarak ele alınır.
                </p>

                <div className="my-7 rounded-2xl border border-emerald-100 bg-emerald-50/80 p-5">
                  <h3 className="text-xl font-bold text-[#0f3d2e] mb-4">
                    Abone Halı Yıkama Avantajları
                  </h3>

                  <ul className="grid gap-3 text-left">
                    <li>✓ Yenimahalle genelinde yerinden alım ve teslimat</li>
                    <li>✓ Halı, koltuk, perde, yorgan ve battaniyede tam çözüm</li>
                    <li>✓ Halı türüne göre uygun yıkama yöntemi</li>
                    <li>✓ Antibakteriyel ve hijyen odaklı temizlik süreci</li>
                    <li>✓ Leke, koku, toz ve alerjenlere karşı detaylı temizlik</li>
                    <li>✓ Zamanında teslim ve müşteri memnuniyeti odaklı hizmet</li>
                  </ul>
                </div>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Yenimahalle Koltuk Yıkama Hizmeti
                </h2>

                <p>
                  Koltuk yıkama işleminde kumaş yapısına uygun temizlik ürünleri
                  ve profesyonel ekipmanlar kullanılır. Günlük kullanımda
                  koltuklara işleyen toz, ter, yemek lekesi, evcil hayvan tüyü
                  ve kötü kokular detaylı temizlik işlemiyle azaltılır. Kumaşa
                  zarar vermeden hijyenik ve ferah bir görünüm hedeflenir.
                </p>

                <h2 className="text-2xl font-bold text-[#1f160f] text-left">
                  Yenimahalle’de Hizmet Verdiğimiz Bölgeler
                </h2>

                <p>
                  Batıkent, Demetevler, İvedik, Çakırlar, Karşıyaka, Ostim,
                  Ergazi, Ata, Serhat, Kentkoop, Turgut Özal, Kardelen ve
                  Yenimahalle çevresindeki birçok noktaya hızlı servis
                  sağlıyoruz. Bölgenize göre teslim alma ve teslim etme planı
                  oluşturulur.
                </p>

                <div className="rounded-2xl bg-[#fff7df] border border-[#ead9b7] p-5">
                  <h3 className="text-xl font-bold text-[#2b160b] mb-3">
                    Yenimahalle Halı Yıkama Fiyatları
                  </h3>
                  <p>
                    Yenimahalle halı yıkama fiyatları; halı türü, metrekare,
                    leke durumu ve ek hizmetlere göre değişebilir. En doğru
                    fiyat bilgisi için bizi arayabilir veya WhatsApp üzerinden
                    halı ölçüsü ve hizmet talebinizi iletebilirsiniz.
                  </p>
                </div>

                <p>
                  Abone Halı Yıkama olarak amacımız sadece halılarınızı yıkamak
                  değil; evinize daha temiz, daha ferah ve daha hijyenik bir
                  yaşam alanı kazandırmaktır. Yenimahalle halı yıkama ve koltuk
                  yıkama hizmetleri için hemen iletişime geçebilirsiniz.
                </p>
              </div>

              <div className="mt-8 space-y-6">
                <YenimahalleSidebar />
                <YenimahalleOtherServices />
              </div>
            </article>
          </main>

          <aside className="order-3 lg:col-span-3 lg:sticky lg:top-28 space-y-6">
            <div className="rounded-[26px] border border-[#e7d7b4] bg-white/90 p-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
              <RightSidebar />
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default YenimahalleIntro;